import * as types from './mutation_types'

export default {
  [types.SET_VCP_CONFIG] (state, newConfig) {
    state.vcpConfig = newConfig
    // TODO: выпилить с раскаткой сайта
    // if (!window.visualSetTime) {
    //   window.visualSetTime = []
    // }
    // window.visualSetTime.push(Date.now())
    // if (window.visualSetTime.length > 1) {
    //   console.log('visual diff', window.visualSetTime[1] - window.visualSetTime[0])
    // }
  },
  [types.SET_CURRENT_TARGET] (state, newTaRGET) {
    state.currentTarget = newTaRGET
  },
  [types.SET_VCP_CONFIG_LOADED] (state, value) {
    state.vcpConfigLoaded = value
  },
  [types.SET_VCP_HASH] (state, hash) {
    state.vcpHash = hash
  },
}
